// Item 409 — renders its children only when the event has a skeleton to show (see usePoseAvailable).
// Mounted for superusers only, so everyone else needs no QueryClient and makes no request.
import type { ReactNode } from 'react'
import { usePoseAvailable } from '@/hooks/usePoseAvailable'
import type { Event } from '@/types'

export function PoseGate({ event, children }: { event: Event; children: ReactNode }) {
  return usePoseAvailable(event) ? <>{children}</> : null
}
